import thunkMiddleware from 'redux-thunk';
// import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';

// const loggerMiddleware = createLogger()
// const middlewares = [thunkMiddleware];

let store = createStore(rootReducer, composeWithDevTools(
  applyMiddleware(thunkMiddleware),
));

if (process.env.NODE_ENV === 'production') {
  store = createStore(rootReducer, applyMiddleware(thunkMiddleware));
}

export default store;
